import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { LocalStorageService } from 'ngx-webstorage';

@Component({
  selector: 'app-logout',
  standalone: true,
  imports: [TranslateModule, RouterModule],
  templateUrl: './logout.component.html',
  styles: [':host { height: 100%; width: 100%; display: block;}']
})
export class LogoutComponent implements OnInit { // This is a closing page to cleanup storage after successfully logged out from MSAL
  ngOnInit(): void {
    this.localStorageService.clear();
    window.sessionStorage.clear();
    this.router.navigate(['/login']);
  }
  
  constructor(private readonly router: Router, private readonly localStorageService: LocalStorageService) {}
}